import { debugLog, calculateScrollbarWidth } from './library/helpers';

document.addEventListener( 'DOMContentLoaded', () => {
    
    const menu = document.querySelector( '#menu-main' );
    const toggleBtnMenu = document.getElementById("menu-toggle") as HTMLButtonElement;
    const body = document.body;


    calculateScrollbarWidth();

    if ( menu && toggleBtnMenu ) {
        toggleBtnMenu.addEventListener("click", () => {
            const isOpen = toggleBtnMenu.classList.toggle("open");
            body.classList.toggle("menu-visible", isOpen);
            toggleBtnMenu.setAttribute("aria-expanded", String(isOpen));
        });
    }
});
window.addEventListener("resize", calculateScrollbarWidth);
